import { getActivePinia, Store } from 'pinia';

import useAlertsStore from '@/stores/alerts';
import useCreditCardsStore from '@/stores/creditCards';
import useCreditReport from '@/stores/creditReport';
import { useFeatureStore } from '@/stores/features';
import useLoansStore from '@/stores/loans';
import useStore from '@/stores/main';
import useOutcomeStore from '@/stores/outcome';
import useProfileStore from '@/stores/profile';
import useUserStore from '@/stores/user';

const clearSession = () => {
  const creditCardsStore = useCreditCardsStore();
  const loansStore = useLoansStore();
  const outcomeStore = useOutcomeStore();

  creditCardsStore.clearSession();
  loansStore.clearSession();
  outcomeStore.clearSession();
};

const resetAllPiniaStores = () => {
  const pinia = getActivePinia();

  if (pinia) {
    const activeStores = Object.keys(pinia.state.value);

    activeStores.forEach((store) => {
      if ('_s' in pinia) (pinia._s as Map<string, Store>).get(store)?.$reset();
    });
  }

  clearSession();
};

export {
  clearSession,
  resetAllPiniaStores,
  useAlertsStore,
  useCreditCardsStore,
  useCreditReport,
  useFeatureStore,
  useLoansStore,
  useOutcomeStore,
  useProfileStore,
  useStore,
  useUserStore
};
